module.exports = __webpack_public_path__ + "static/media/isbark.60e072ea.PNG";